import { render } from "./MailRecipientPill.vue?vue&type=template&id=4510a627"
import script from "./MailRecipientPill.vue?vue&type=script&lang=js"
export * from "./MailRecipientPill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__